﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyDisclaimerRef", [
    "DisclaimersService",
    function (DisclaimersService) {
      var link = function ($scope, $element) {
        function sanitizeTextAsDisclaimerId(text) {
          return text.replace(/\s/g, "");
        }

        function updateDisclaimerId() {
          var disclaimerId = sanitizeTextAsDisclaimerId($element.text());
          $scope.disclaimerId = disclaimerId;
          $scope.disclaimerLink = "#disclaimer_" + disclaimerId;
        }

        updateDisclaimerId();

        if ($scope.watchVisibility === "true") {
          $scope.$watch(
            function () {
              return $element.is(":visible");
            },
            function (newVal, oldVal) {
              if (newVal && !oldVal) {
                if ($scope.disclaimerId.length) {
                  DisclaimersService.addToGroup("disclaimer-ref-group", $scope.disclaimerId);
                }
              }
            }
          );
        }

        if ($scope.watchContent === "true") {
          $scope.$watch(
            function () {
              return sanitizeTextAsDisclaimerId($element.text());
            },
            function (newVal) {
              updateDisclaimerId();

              if ($scope.disclaimerId.length) {
                DisclaimersService.addToGroup("disclaimer-ref-group", newVal);
              }
            }
          );
        }

        if ($scope.disclaimerId.length) {
          DisclaimersService.addToGroup("disclaimer-ref-group", $scope.disclaimerId);
        }
      };

      return {
        scope: {
          watchVisibility: "@?watchVisibility",
          watchContent: "@?watchContent",
        },
        restrict: "E",
        link: link,
        template: '<sup class="ty-disclaimer-ref"><ng-transclude></ng-transclude></sup>',
        transclude: true,
        replace: true,
      };
    },
  ]);
})(window.angular);
